import React, { useEffect, useState, Fragment } from 'react';
import {
    Grid,
    Button,
    Box,
    Modal,
    Typography,
    CardContent,
    Card,
} from '@mui/material';
import { useFormik } from 'formik';
import { validationschat, valuesChat } from './formikData';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Checkbox, FormControlLabel } from '@mui/material';
import { IFormChat } from '../../../shared/types/chat';
import { AuthMessages } from '../../../shared/messages/authMessages';
import FieldText from '../../components/general/fields/fieldText';
import AutocompleteField from '../../components/general/fields/autocompleteField';
import { ToastSwal } from '../../components/general/toastSwals/toastSwal';
import { ISelect, ParamEnum } from '../../../shared/types/shared';

import {
    asyncGetParamByCode,
    asyncGetParams,
} from '../../../services/param.service';
import { GuidoBanner } from '../../components/general/guidoBanner';
import { ContainerChat } from '../../components/general/containerChat';
import { formatParams } from '../../../shared/utils/params';

const chatWeb = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [identifications, setIdentifications] = useState<ISelect[]>([]);
    const [NIT, setNIT] = useState<ISelect>();
    const [inChat, setInChat] = useState(false);
    const [contacts, setContacts] = useState<ISelect[]>([]);
    const [open, setOpen] = useState(false);

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const getReCaptcha = async () => {
        try {
            if (executeRecaptcha) {
                const localToken = await executeRecaptcha('someAction');
                return localToken;
            }
        } catch (error) {
            console.error('Error al obtener reCAPTCHA:', error);
            return null;
        }
    };

    const iniciarChat = (values: IFormChat) => {
        setInChat(true);
        document.getElementById('chat-client-v4')?.remove();
        document.getElementById('chat-client-v4-script')?.remove();
        document.getElementById('chat-client-v4-script2')?.remove();

        const link = document.createElement('link');
        link.setAttribute('type', 'text/css');
        link.setAttribute('rel', 'stylesheet');
        link.setAttribute('href', process.env.REACT_APP_CHAT_APP_CSS || '');
        link.setAttribute('id', 'chat-client-v4');

        // Crear el objeto de configuración del chat
        const chatConfig = {
            appId: process.env.REACT_APP_CHAT_APP_ID_WEB,
            apiUrl: process.env.REACT_APP_CHAT_API_URL_WEB,
            tenantUrl: process.env.REACT_APP_CHAT_TENANT_URL_WEB,
            chatPath: process.env.REACT_APP_CHAT_PATH_WEB,
            first_name: values.name,
            last_name: values.surname,
            email: values.email,
            parameters: {
                tipoId: values.type_identification,
                numeroId: values.identification,
                tipoContacto: values.type_contact,
            },
            autostartChat: true,
        };

        // Crear la etiqueta script para cargar el archivo JavaScript
        const script = document.createElement('script');
        script.setAttribute('type', 'text/javascript');
        script.setAttribute('id', 'chat-client-v4-script');
        script.innerHTML = `SERVICE_PATTERN_CHAT_CONFIG = ${JSON.stringify(
            chatConfig
        )};`;

        const scriptSrc = document.createElement('script');
        scriptSrc.setAttribute('id', 'chat-client-v4-script2');
        scriptSrc.setAttribute(
            'src',
            process.env.REACT_APP_CHAT_APP_SCRIPT || ''
        );

        // Agregar los elementos al DOM
        document.body.appendChild(link);
        document.body.appendChild(script);
        document.body.appendChild(scriptSrc);
    };

    const isFormValid = () => {
        return (
            formik.dirty &&
            formik.isValid &&
            Object.keys(formik.errors).length === 0
        );
    };

    const formik = useFormik({
        initialValues: valuesChat,
        validationSchema: validationschat(NIT?.id || ''),
        onSubmit: async (formChat) => {
            const captcha = (await getReCaptcha()) || '';

            if (!captcha) {
                ToastSwal.fire({
                    text: AuthMessages.login['AUTH-NO-CAPTCHA'],
                    icon: 'error',
                    iconColor: '#1d1d1d',
                });
            } else {
                iniciarChat(formChat);
            }
        },
    });

    const handleRestart = () => {
        location.reload();
    };

    const getIdentifications = async () => {
        const items = await asyncGetParams(ParamEnum.DOCUMENT_TYPE);
        setIdentifications(
            items.map(({ code, name }: any) => ({ id: code, name }))
        );

        setNIT(await asyncGetParamByCode(`NIT`));
    };

    const getContacts = async () => {
        const items = await asyncGetParams(ParamEnum.CONTACT_TYPE);
        setContacts(items.map(({ code, name }: any) => ({ id: code, name })));
    };

    useEffect(() => {
        getIdentifications();
        getContacts();
    }, []);

    return (
        <>
            <GuidoBanner></GuidoBanner>
            <ContainerChat>
                <Fragment>
                    <Box>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Box mb={1}>
                                    <label className="crmware-previsora-label">
                                        Nombres{' '}
                                        <b className="crmware-previsora-label-required">
                                            *
                                        </b>
                                        :
                                    </label>
                                </Box>
                                <FieldText
                                    name="name"
                                    size="small"
                                    touched={formik.touched.name}
                                    errors={formik.errors.name}
                                    value={formik.values.name}
                                    onChange={(event) => {
                                        const { value } = event.target;
                                        if (/^[A-Za-z ]*$/.test(value)) {
                                            formik.handleChange(event);
                                        }
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Box mb={1}>
                                    <label className="crmware-previsora-label">
                                        Apellidos{' '}
                                        <b className="crmware-previsora-label-required">
                                            *
                                        </b>
                                        :
                                    </label>
                                </Box>
                                <FieldText
                                    name="surname"
                                    size="small"
                                    touched={formik.touched.surname}
                                    errors={formik.errors.surname}
                                    value={formik.values.surname}
                                    onChange={(event) => {
                                        const { value } = event.target;
                                        if (/^[A-Za-z ]*$/.test(value)) {
                                            formik.handleChange(event);
                                        }
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Box mb={1}>
                                    <label className="crmware-previsora-label">
                                        Tipo de Identificación{' '}
                                        <b className="crmware-previsora-label-required">
                                            *
                                        </b>
                                        :
                                    </label>
                                </Box>
                                <AutocompleteField
                                    data={formatParams(identifications)}
                                    size="small"
                                    name="type_identification"
                                    touched={formik.touched.type_identification}
                                    errors={formik.errors.type_identification}
                                    value={formik.values.type_identification}
                                    onChangeValue={(value: any) =>
                                        formik.setFieldValue(
                                            'type_identification',
                                            value
                                        )
                                    }
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Box mb={1}>
                                    <label className="crmware-previsora-label">
                                        Número de documento{' '}
                                        <b className="crmware-previsora-label-required">
                                            *
                                        </b>
                                        :
                                    </label>
                                </Box>
                                <FieldText
                                    name="identification"
                                    size="small"
                                    touched={formik.touched.identification}
                                    errors={formik.errors.identification}
                                    value={formik.values.identification}
                                    onChange={(event) => {
                                        const { value } = event.target;
                                        if (
                                            /^\d*$/.test(value) ||
                                            value.includes('-')
                                        ) {
                                            formik.handleChange(event);
                                        }
                                    }}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Box mb={1}>
                                    <label className="crmware-previsora-label">
                                        Correo{' '}
                                        <b className="crmware-previsora-label-required">
                                            *
                                        </b>
                                        :
                                    </label>
                                </Box>
                                <FieldText
                                    name="email"
                                    size="small"
                                    touched={formik.touched.email}
                                    errors={formik.errors.email}
                                    value={formik.values.email}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <Box mb={1}>
                                    <label className="crmware-previsora-label">
                                        Asunto{' '}
                                        <b className="crmware-previsora-label-required">
                                            *
                                        </b>
                                        :
                                    </label>
                                </Box>
                                <AutocompleteField
                                    data={formatParams(contacts)}
                                    size="small"
                                    name="type_contact"
                                    touched={formik.touched.type_contact}
                                    errors={formik.errors.type_contact}
                                    value={formik.values.type_contact}
                                    onChangeValue={(value: any) =>
                                        formik.setFieldValue(
                                            'type_contact',
                                            value
                                        )
                                    }
                                    onBlur={formik.handleBlur}
                                />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                display="flex"
                                justifyContent="center"
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            className="checkbox_boot"
                                            id="policy"
                                            name="aceptoPolitica"
                                            checked={formik.values.acceptPolicy}
                                            onChange={() => {
                                                formik.setFieldValue(
                                                    'acceptPolicy',
                                                    !formik.values.acceptPolicy
                                                );
                                            }}
                                            onBlur={formik.handleBlur}
                                        />
                                    }
                                    label={
                                        <label
                                            onClick={handleOpen}
                                            className="link-button"
                                        >
                                            Confirmo que acepto el tratamiento
                                            de datos personales.
                                        </label>
                                    }
                                />
                                {/* Modal */}
                                <Modal
                                    open={open}
                                    onClose={handleClose}
                                    aria-labelledby="modal-title"
                                    aria-describedby="modal-description"
                                >
                                    <Box className="modal-card-container">
                                        <Card className="modal-card">
                                            <CardContent>
                                                <Typography
                                                    id="modal-title"
                                                    variant="h6"
                                                    component="h2"
                                                    className="modal-card-title"
                                                >
                                                    Tratamiento de datos
                                                    personales
                                                </Typography>
                                                <Typography
                                                    id="modal-description"
                                                    variant="body2"
                                                    component="p"
                                                    className="modal-card-content"
                                                >
                                                    Autorizo expresamente a La
                                                    Previsora S.A, Compañía de
                                                    Seguros, con NIT.
                                                    860002400-2 como responsable
                                                    del tratamiento de la
                                                    información, para utilizar
                                                    mi nombre, teléfono de
                                                    contacto, correo electrónico
                                                    y demás datos personales
                                                    compartidos con la compañía
                                                    con el fin de:
                                                    <br />
                                                    <br />
                                                    a) Realizar gestiones de
                                                    conocimiento al cliente y
                                                    verificación o actualización
                                                    de información a través de
                                                    cualquier medio; b) Tramitar
                                                    solicitudes o recibir
                                                    información general,
                                                    automóviles, SOAT, hogar,
                                                    áreas comunes y otros ramos;
                                                    c) Enviar correspondencia,
                                                    correos electrónicos,
                                                    mensajes de texto (SMS) o
                                                    hacer contacto telefónico en
                                                    desarrollo de actividades
                                                    publicitarias, de mercadeo,
                                                    ofrecimiento de productos o
                                                    servicios nuevos y actuales;
                                                    d) Compartir esta
                                                    información con terceros
                                                    conforme se haga necesario
                                                    para realizar actividades
                                                    comprendidas dentro de su
                                                    objeto social; e) Realizar
                                                    encuestas de satisfacción y
                                                    percepción sobre los
                                                    productos y servicios de la
                                                    compañía por cualquier
                                                    medio; f) Para la prestación
                                                    de todos los servicios
                                                    convenidos dentro del
                                                    contrato de seguros en caso
                                                    que tenga la calidad de
                                                    asegurado o beneficiario.
                                                    <br />
                                                    <br />
                                                    Para más información sobre
                                                    la Política de privacidad de
                                                    la compañía, así como los
                                                    derechos de los titulares de
                                                    la información y la manera
                                                    de ejercerlos es posible
                                                    acceder a la página de
                                                    internet
                                                    www.previsora.gov.co.
                                                </Typography>
                                                <Box
                                                    sx={{
                                                        textAlign: 'right',
                                                        mt: 3,
                                                    }}
                                                >
                                                    <Button
                                                        variant="contained"
                                                        className="modal-card-button"
                                                        onClick={handleClose}
                                                    >
                                                        Acepto
                                                    </Button>
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Box>
                                </Modal>
                            </Grid>

                            <Grid item xs={12} sx={{ textAlign: 'center' }}>
                                <Button
                                    type="submit"
                                    className="crmware-previsora-btn-primary"
                                    disabled={!isFormValid()}
                                    onClick={formik.handleSubmit as any}
                                >
                                    Iniciar Chat
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                </Fragment>
            </ContainerChat>

            {inChat && (
                <Grid
                    position="absolute"
                    width="100%"
                    height="100%"
                    top={0}
                    left={0}
                    bgcolor="#000000AA"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                >
                    <img
                        src={require('../../../assets/images/logos/logo.png')}
                        width="40%"
                    />
                    <Button
                        type="submit"
                        className="crmware-previsora-btn-primary"
                        onClick={handleRestart}
                    >
                        ¿Reiniciar Chat?
                    </Button>
                </Grid>
            )}
        </>
    );
};

export default chatWeb;
